export enum LoadingKeys {
    USE_ARTICLE_API = "useArticleApi",
    USE_SPECIALIST_API = "useSpecialistApi",
    USE_FILE_UPLOAD = "useFileUpload",
    USE_EXERCISE_API = "useExerciseApi",
    USE_APP_METADATA_API = "useAppMetadataApi",
    USE_STATISTICS_API = "useStatisticsApi"
}
